import { render, staticRenderFns } from "./ButtonPhoneCall.vue?vue&type=template&id=6cc71902&scoped=true&lang=pug"
import script from "./ButtonPhoneCall.vue?vue&type=script&lang=js"
export * from "./ButtonPhoneCall.vue?vue&type=script&lang=js"
import style0 from "./ButtonPhoneCall.vue?vue&type=style&index=0&id=6cc71902&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc71902",
  null
  
)

export default component.exports